import { css } from '@emotion/react';

interface Props {
  fromSize: number;
  toSize: number;
  fromViewport: number;
  toViewport: number;
  axis?: 'x' | 'y';
}

export const helperFluidTypography = ({
  fromSize,
  toSize,
  fromViewport,
  toViewport,
  axis = 'x'
}: Props) => css`
  font-size: ${toSize}px;

  @media ${axis === 'y' ? `(max-height: ${toViewport}px)` : `(max-width: ${toViewport}px)`} {
    font-size: calc(
      ${fromSize}px + (${toSize} - ${fromSize}) *
        (
          (${axis === 'y' ? '100vh' : '100vw'} - ${fromViewport}px) /
            (${toViewport} - ${fromViewport})
        )
    );
  }

  @media ${axis === 'y' ? `(max-height: ${fromViewport}px)` : `(max-width: ${fromViewport}px)`} {
    font-size: ${fromSize}px;
  }
`;
